// apps/web/src/features/commercial-proposals/download.ts
//
// @aiPurpose imperative browser-download trigger for the proposal PDF
//   (#1198): create an object URL for the blob, click a hidden anchor, then
//   revoke the URL on the next tick. Kept feature-local (mirrors the
//   requests export trigger) so the API helper stays free of DOM coupling
//   and cross-feature imports stay clean.
export function triggerBrowserDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  // Revoke after the click handler returns so the browser has committed the
  // download; a synchronous revoke can race the download initiation.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
